import { Controller } from "@hotwired/stimulus"

// Keeps each native colour picker and its hex text input in sync (matched by
// data-colour-key). That is ALL it does since TASK-134.1: the CSS mock
// preview this controller used to paint is retired — the studio's live render
// is the preview — so the option/preset machinery went with it. Used by the
// studio's Colours accordion and the admin global-row editor.
export default class extends Controller {
  static targets = ["picker", "hex"]

  pickerChanged(event) {
    const hex = event.target.value.replace("#", "").toUpperCase()
    const input = this.hexTargets.find((t) => t.dataset.colourKey === event.target.dataset.colourKey)
    if (input) input.value = hex
  }

  hexChanged(event) {
    const value = event.target.value.trim().replace("#", "")
    if (/^[0-9a-fA-F]{6}$/.test(value)) {
      const picker = this.pickerTargets.find((t) => t.dataset.colourKey === event.target.dataset.colourKey)
      if (picker) picker.value = `#${value}`
    }
  }
}
